export const gasLanes = [
  {
    value: '100',
    label: '100 gwei',
  },
]
